<template>
  <v-row v-scroll="onScroll">
     <!-- header -->
    <mini-header :breadcrumbs="breadcrumbs" :hiddenTab="true" :dense="true" :scroll="scroll">
      <template v-slot:main>
        <v-btn color="grey-900" @click="handleCreateCategory"><v-icon left>mdi-plus-box</v-icon>Crear categoría</v-btn>
      </template>
    </mini-header>
   <!-- end header -->
    <v-col class="pa-0 mt-0 mb-10">
      <VSkeleton class="mt-6" v-if="loading" />
      <template v-else>
        <v-col cols="12" class="px-0 mt-2">
          <template v-if="categoriesList.length">
            <v-row>
              <v-col class="pa-2 d-flex" v-for="(d, index) in categoriesList" :key="`${d.id}-${index}`" cols="6" md="4">
                <v-hover v-slot="{ hover }">
                  <v-card
                    class="pa-5 rounded-md d-flex flex-column"
                    style="width: 100%;"
                    @click.stop="$router.push({ name: 'SuppliersCategoriesRetrieveUpdate', params: { id: d?.id ?? 'null' } })"
                    :elevation="hover ? 5 : 0"
                    flat
                  >
                    <v-row align="start" no-gutters style="height: 50px;">
                      <v-col cols="11" class="pa-0 d-flex align-center">
                        <v-avatar :color="isDefaultSegment(d.id) ? 'yellow-100' : (d.name === 'Bloqueados' ? 'grey-200' : 'green-100')" size="32">
                          <v-icon :color="isDefaultSegment(d.id) ? 'yellow-500' : (d.name === 'Bloqueados' ? 'grey-300' : 'green-500')" size="20">mdi-{{ d.name === 'Bloqueados' ? 'lock' : 'folder' }}</v-icon>
                        </v-avatar>
                        <span :class="`${isDefaultSegment(d.id) ? 'grey-200' : 'grey-500'}--text pl-3 font-weight-semibold subtitle-2 line-clamp-2 `" style="flex: 1; max-width: 90%; padding-top: 6px;">{{ isDefaultSegment(d.id) ? 'Sin categoría' : d.name }}</span>
                      </v-col>
                      <v-spacer />
                      <v-menu v-if="!isDefaultSegment(d.id)" v-model="menu[index]" close-on-click offset-y left :nudge-bottom="0" :nudge-left="10" transition="slide-y-transition" :min-width="182">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-n1 mr-n2" text v-bind="attrs" v-on="on" :ripple="false" @click.stop>
                            <v-icon color="grey-500" size="24">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pa-0 pb-2">
                          <v-list-item class="px-3 mt-1" @click.stop="handleCategory(d)" active-class="transparent" :ripple="false">
                            <v-list-item-title class="body-2">Editar categoría</v-list-item-title>
                          </v-list-item>
                          <v-list-item class="px-3" v-if="d.qty_members === 0" @click.stop="handleDestroyCategory(d.id)" active-class="transparent" :ripple="false">
                            <v-list-item-title class="body-2">Eliminar categoría</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-row>
                    <div class="pt-2 flex-grow-1 d-flex align-start" style="line-height: 1;">
                      <span class="grey-500--text body-1" v-if="isDefaultSegment(d.id)">No presenta clasificación específica</span>
                      <span class="grey-500--text body-1" v-else-if="d.description">{{d.description}}</span>
                      <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                    </div>
                    <div class="pt-3 mt-auto">
                      <span class="grey-300--text body-1 d-block">Proveedores</span>
                      <span class="d-block mt-n1 grey-300--text font-weight-bold subtitle-q">{{d.qty_members ?? 0}}</span>
                    </div>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </template>
          <div v-else class="d-flex justify-center align-center" style="width: 100%; min-height: calc(100vh - 300px);">
            <v-empty-state title="No existen categorías para mostrar" :isFree="true" type="suppliers" :height="200" customClass="mt-5" :hiddenDescription="true" />
          </div>
        </v-col>
      </template>
    </v-col>

    <!-- dialog edit category -->
    <v-dialog v-model="dialogCategory" width="650" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Editar categoría</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogCategory=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pb-4 pt-5 px-5" style="max-height: 600px !important;">
          <v-list class="pa-0 transparent v-list-form-card">
            <v-list-item class="pb-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.name.$model" :error="$v.editable.name.$error" outlined required single-line dense maxlength="100" hide-details placeholder="Escribe el nombre de la categoría"/>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.editable.description.$model" :error="$v.editable.description.$error" outlined required single-line dense maxlength="200" hide-details placeholder="Escribe una descripción de la categoría"/>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer/>
          <v-btn outlined @click="dialogCategory=false">Cancelar</v-btn>
          <v-btn color="grey-900" @click="editCategory" :loading="editCategoryLoading">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog edit category -->

     <!-- dialog confirm delete -->
     <v-dialog v-model="dialogDelete" width="700" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Eliminar categoría</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogDelete=false, confirm=''" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5">
          <v-alert class="inf-alert-yellow yellow-700--text rounded-md mb-4" dense outlined>
            <div class="d-flex pa-0 align-center">
              <v-icon color="yellow-700">mdi-alert-outline</v-icon>
              <div class="ml-4">
                <span class="body-1 font-weight-bold yellow-700--text">Atención</span>
                <span class="d-block body-2 yellow-700--text">Al eliminar la categoría, los proveedores no tendrán categorías asociadas y estarán sujetos a las reglas de automatización para proveedores sin categorías.</span>
              </div>
            </div>
          </v-alert>
          <span class="d-block grey-500--text mb-2">Escribe <span class="font-weight-bold">"confirmar"</span> para continuar.</span>
          <v-text-field v-model="confirm" outlined single-line maxlength="9" hide-details @keyup.enter="confirm.toLowerCase() === 'confirmar' && destroyCategory()" />
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="dialogDelete=false, confirm=''" outlined>Cancelar</v-btn>
          <v-btn color="grey-900" @click="destroyCategory" :disabled="confirm.toLowerCase() !== 'confirmar'">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog confirm delete -->

    <!-- dialog new category -->
    <v-dialog v-model="dialogCreateCategory" width="650" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Crear categoría</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogCreateCategory=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pb-4 pt-6 px-5" style="max-height: 600px !important;">
          <v-list class="pa-0 transparent v-list-form-card">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.newCategory.name.$model" :error="$v.newCategory.name.$error" outlined required single-line dense maxlength="100" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="pb-2 pt-2">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="newCategory.description" outlined required single-line dense maxlength="100" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer/>
          <v-btn outlined @click="dialogCreateCategory=false">Cancelar</v-btn>
          <v-btn color="grey-900" @click="createCategory" :loading="createCategoryLoading">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog new category -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import PermissionDenied from '@/modules/http/views/PermissionDenied'
import SkeletonList from '@/components/commons/skeletonLoader/SkeletonList'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import MiniHeader from '@/components/commons/MiniHeader'
import { required, maxLength } from 'vuelidate/lib/validators'
import VEmptyState from '@/components/commons/VEmptyState'
import VSkeleton from '@/modules/pos/pos/components/complements/VSkeletonPos'
import ListViewMixin from '@/mixins/ListViewMixin'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'

export default {
  components: {
    VTableHeaders,
    SkeletonList,
    VEmptyState,
    VSkeleton,
    VQueryBuilder,
    MiniHeader,
    PermissionDenied
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    defaultSegmentId: 'se_AAAAAAAAAAAAAAAA',
    dialogCreateCategory: false,
    createCategoryLoading: false,
    confirm: '',
    dialogDelete: false,
    editCategoryLoading: false,
    dialogCategory: false,
    menu: [false],
    menu1: [false],
    scroll: 0,
    loading: false,
    activeFilter: false,
    filters: [
      {
        type: 'text',
        id: 'name',
        label: 'Nombre',
        value: null,
        category: 'a',
        operators: [''],
        countries: ['PE', 'CL']
      }
    ],
    editable: {
      name: '',
      visibility: 1,
      description: '',
      pos: [],
      members: []
    },
    currentDelete: '',
    breadcrumbs: {
      main: 'Recepción',
      children: [
        {
          text: 'Categorías'
        }
      ]
    },
    newCategory: {
      name: '',
      visibility: 1,
      description: '',
      suppliers: []
    }
  }),
  computed: {
    ...mapState({
      groupsList: state => state.suppliers.segmentsList,
      count: state => state.suppliers.segmentsCount,
      suppliersList: state => state.suppliers.suppliersList
    }),
    categoriesList () {
      if (!this.groupsList.length) return []
      return [...this.groupsList].sort((a, b) => {
        if (a.id === this.defaultSegmentId) return 1
        if (b.id === this.defaultSegmentId) return -1
        return 0
      })
    },
    isDefaultSegment () {
      return (id) => id === this.defaultSegmentId
    }
  },
  created () {
    this.getList()
  },
  methods: {
    handleCreateCategory () {
      this.dialogCreateCategory = true
    },
    createCategory () {
      this.$v.newCategory.$touch()
      if (this.$v.newCategory.$invalid) {
        return false
      }

      this.createCategoryLoading = true
      let payload = this.newCategory
      payload.suppliers = payload.suppliers.map(({id}) => id)

      this.$store.dispatch('suppliers/CREATE', {
        resource: 'segments',
        query: this.$route.query,
        payload: payload
      })
     .then(() => {
       this.$dialog.message.info('La categoría ha sido creada con éxito.')
        this.getList()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.$v.newCategory.$reset()
        this.dialogCreateCategory = false
        this.createCategoryLoading = false
        this.newCategory = {
          name: '',
          visibility: 1,
          description: '',
          suppliers: [],
          members: []
        }
      })
    },
    onScroll (e) {
      this.scroll = e.target?.scrollingElement?.scrollTop ?? 0
    },
    async getList () {
      this.loading = true
      try {
        await this.$store.dispatch('suppliers/LIST', {
          resource: 'segments',
          query: this.$route.query
        })
      } finally {
        this.loading = false
      }
    },
    handleCategory (item = {}) {
      this.dialogCategory = true
      this.editable = {
        id: item.id,
        name: item.name,
        visibility: item.visibility,
        description: item.description
      }
    },
    supplierRemove (item) {
      const index = this.newCategory.suppliers.indexOf(item)
      if (index >= 0) this.newCategory.suppliers.splice(index, 1)
    },
    handleDestroyCategory (category = '') {
      this.currentDelete = category
      this.dialogDelete = true
    },
    editCategory () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }

      this.editCategoryLoading = true

      const payload = {
        name: this.editable.name,
        description: this.editable.description
      }

      this.$store.dispatch('suppliers/UPDATE', {
        resource: `segments/${this.editable.id}`,
        payload: payload
      })
      .then(() => {
        this.getList()
        this.$dialog.message.info('La categoría se ha actualizado con éxito.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.$v.editable.$reset()
        this.editable = {
          name: '',
          visibility: 1,
          description: '',
          pos: [],
          members: []
        }
        this.dialogCategory = false
        this.editCategoryLoading = false
      })
    },
    destroyCategory () {
      this.$store.dispatch('suppliers/DESTROY', {
        resource: 'segments',
        id: this.currentDelete
      })
      .then(() => {
        this.$dialog.message.info('La categoría se ha eliminado con éxito')
        this.getList()
        this.addOrRemoveMenu(this.currentDelete)
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.currentDelete = ''
        this.confirm = ''
        this.dialogDelete = false
      })
    },
    remove (item) {
      const index = this.editable.members.indexOf(item)
      if (index >= 0) this.editable.members.splice(index, 1)
    }
  },
  validations: {
    newCategory: {
      name: { required, maxLength: maxLength(100) },
      description: { maxLength: maxLength(200) }
    },
    editable: {
      name: { required, maxLength: maxLength(100) },
      description: { maxLength: maxLength(200) }
    }
  }
}
</script>
<style scoped>
.inf-alert-yellow.v-alert--outlined {
  border-color: var(--light-yellow-700) !important;
  background-color: var(--light-yellow-100) !important;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
</style>
